export default __webpack_public_path__ + "static/media/payment-zalopay.2a247fbe.svg";